import { useTranslation } from 'react-i18next';
import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts';

interface BudgetVsActualGaugeProps {
  fixedPrice: number;
  actualCost: number;
  label?: string;
}

export default function BudgetVsActualGauge({ fixedPrice, actualCost, label }: BudgetVsActualGaugeProps) {
  const { t } = useTranslation();
  const pct = fixedPrice > 0 ? Math.round((actualCost / fixedPrice) * 100) : 0;
  const isOver = actualCost > fixedPrice;

  const data = [
    { name: t('charts.budget'), value: 100, fill: '#e2e8f0' },
    { name: t('charts.actual'), value: Math.min(pct, 100), fill: isOver ? '#ef4444' : pct > 80 ? '#f59e0b' : '#22c55e' },
  ];

  return (
    <div className="card">
      <h3 className="text-sm font-semibold text-surface-700 mb-2">{label || t('charts.budgetVsActual')}</h3>

      {isOver && (
        <div className="px-3 py-2 rounded-lg bg-danger-50 text-danger-700 text-xs font-medium mb-3 border border-danger-100">
          {t('charts.overBudget')}
        </div>
      )}

      <div className="flex items-center justify-center">
        <ResponsiveContainer width={200} height={200}>
          <RadialBarChart
            cx="50%" cy="50%" innerRadius="60%" outerRadius="100%"
            barSize={18} data={data} startAngle={180} endAngle={0}
          >
            <RadialBar dataKey="value" cornerRadius={10} />
          </RadialBarChart>
        </ResponsiveContainer>
      </div>

      <div className="text-center -mt-6">
        <p className={`text-2xl font-bold ${isOver ? 'text-danger-600' : 'text-surface-800'}`}>{pct}%</p>
        <p className="text-xs text-surface-500 mt-1">
          ₪{actualCost.toLocaleString()} / ₪{fixedPrice.toLocaleString()}
        </p>
      </div>
    </div>
  );
}
